import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'

Vue.use(Vuex)

export const store = new Vuex.Store({
  
  state: {
    user: null,
    loading: false,
    error: null,
    issues: null,
  },
  // NEVER run async tasks in the mutations section
  mutations: {
    setIssues: function (state, payload) {
      state.issues = payload
    },
    createIssue: function (state, payload) {
      state.issues.push(payload)
    },
    setUser( state, payload ) {
      state.user = payload
    },
    setLoading( state, payload ) {
      state.loading = payload
    },
    setError( state, payload ) {
      state.error = payload
    },
    clearError( state ) {
      state.error = null
    }
  },
  // Where asynchronous tasks are performed
  actions: {
    loadIssues: function ({commit}) {
      firebase.database().ref('issues').once('value')
        .then((data) => {
          const issues = []
          const obj = data.val()
          // Loop through firebase DB objects using the returned data.val()
          for (let key in obj) {
            issues.push({
              id: key,
              title: obj[key].title,
              description: obj[key].description,
              category: obj[key].category,
              priority: obj[key].priority,
              notes: obj[key].notes,
              email: obj[key].email,
              date: obj[key].date
            })
          }
          commit('setIssues', issues)
          commit('setLoading', false)
        })
        .catch(
          (error) => {
            console.log(error)
            commit('setLoading', false)
          }
        )
    },
    createIssue: function ({commit}, payload) {
      const issue = {
        title: payload.title,
        description: payload.description,
        category: payload.category,
        priority: payload.priority,
        notes: payload.notes,
        email: payload.email,
        date: payload.date.toISOString()
      }
      firebase.database().ref('issues').push(issue)
        .then((data) => {
          const key = data.key;
          // commit('createIssue', issue)
          commit('createIssue', {
            ...issue, id: key
          })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    signUserUp( { commit }, payload ) {
      commit( 'setLoading', true )
      commit( 'clearError' )
      firebase.auth().createUserWithEmailAndPassword( payload.email, payload.password )
        .then(
          user => {
            commit( 'setLoading', false )
            const newUser = {
              id: user.uid
            }
            commit( 'setUser', newUser )
          }
        )
        .catch(
          error => {
            commit( 'setLoading', false )
            commit( 'setError', error )
            // TODO: error handling
            console.log( error )
          }
        )
    },
    
    signUserIn( { commit }, payload ) {
      commit( 'setLoading', true )
      commit( 'clearError' )
      firebase.auth().signInWithEmailAndPassword( payload.email, payload.password )
        .then(
          user => {
            commit( 'setLoading', false )
            const newUser = {
              id: user.user.uid
            }
            commit( 'setUser', newUser )
          }
        )
        .catch(
          error => {
            commit( 'setLoading', false )
            commit( 'setError', error )
            console.log( error )
          }
        )
    },
    autoSignIn( { commit }, payload ) {
      commit( 'setUser', { uid: payload.uid } )
    },
    logout( { commit } ) {
      firebase.auth().signOut()
      commit( 'setUser', null )
    },
    clearError( { commit }) {
      commit( 'clearError' )
    },
    // Update the display name of the current user
    updateUserName( { commit }, payload ) {
      var user = firebase.auth().currentUser
      user.updateProfile({
        displayName: payload.name
      }).then( function()  {
        console.log("Updated display name")
        commit( 'setUsername', payload)
      }).catch( function( error ) {
        console.log(error)
      })
    }
  },

  getters: {
    user( state ) {
      return state.user
    },
    username(state) {
      var user = firebase.auth().currentUser;
      return (user !== null) ? user.displayName : 'User Name';
    },
    email: function () {
      return firebase.auth().currentUser.email
    },
    uid: function () {
      return firebase.auth().currentUser.uid
    },
    // status: function () {
    //   return state.status
    // },

    issues: function (state) {
      return state.issues
    },
    loading( state ) {
      return state.loading
    },
    error( state ) {
      return state.error
    }
  }

})

export default store


// WEBPACK FOOTER //
// ./src/stores/UserStore.js